<ion-header class="ion-no-shadow ion-no-border">
    <ion-toolbar>
        <ion-title [innerHTML]="'MESSAGE_FILE_FORM_TITLE' | translate"></ion-title>

        <ion-buttons slot="end">
            <ion-button (click)="backClicked()">
                <ion-icon slot="icon-only"
                          color="dark"
                          name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<div *ngIf="!loading"
     class="message-file-form">

    <ng-container *ngIf="submitting">
        <div class="content-centered-column">
            <div class="content-centered-row">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-container>

    <form *ngIf="!submitting"
          #f="ngForm"
          novalidate
          class="form-horizontal">

        <ion-item>
            <ion-textarea placeholder="{{ 'MESSAGE_FILE_FORM_MESSAGE_PLACEHOLDER' | translate }}"
                          ieTextareaFix
                          name="message"
                          inputmode="text"
                          spellcheck="false"
                          autocapitalize="off"
                          #messageTextarea="ngModel"
                          maxLength="1500"
                          autoGrow="false"
                          [(ngModel)]="message.message">
            </ion-textarea>
        </ion-item>

        <ion-item class="file-list ion-text-center">
            <span *ngIf="image"
                  class="image-link">
                <img [src]="message?.file | safe:'url'">
            </span>
            <div class="file"
                 *ngIf="!image">
                <svg-icon [applyClass]="true"
                          class="file-ico"
                          [src]="'/assets/icons/messages/file.svg'">
                </svg-icon>
                <div class="info">
                    <h3>{{ filename }}</h3>
                </div>
            </div>
        </ion-item>

        <ion-row *ngIf="!plt.sizeSm"
                 class="action-buttons">
            <ion-col class="ion-text-right">
                <ion-button class="btn-close"
                            (click)="backClicked()">
                    {{ 'BUTTON_CANCEL' | translate }}
                </ion-button>

                <ion-button (click)="send()">
                    {{ 'BUTTON_SEND' | translate }}
                </ion-button>
            </ion-col>
        </ion-row>
    </form>
</div>

<ion-footer *ngIf="plt.sizeSm && !submitting">
    <ion-row class="action-buttons two ion-no-padding">
        <ion-col size="6"
                 class="ion-no-padding">
            <ion-button class="btn-close"
                        (click)="backClicked()">
                {{ 'BUTTON_CANCEL' | translate }}
            </ion-button>
        </ion-col>
        <ion-col size="6"
                 class="ion-no-padding">
            <ion-button (click)="send()">
                {{ 'BUTTON_SEND' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>

</ion-footer>